import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "modal-mask"
};
const _hoisted_2 = { class: "modal-wrapper" };
const _hoisted_3 = { class: "modal-header" };
const _hoisted_4 = { class: "modal-body" };
const _hoisted_5 = { class: "modal-footer" };
import { ref } from "vue";
import { onClickOutside } from "@vueuse/core";
export default /*@__PURE__*/ _defineComponent({
    __name: 'BaseModal',
    props: {
        isOpen: { type: Boolean }
    },
    emits: ["modal-close", "submit"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const target = ref(null);
        onClickOutside(target, () => emit('modal-close'));
        const onClose = () => emit('modal-close');
        const onSubmit = () => emit('submit');
        return (_ctx, _cache) => {
            return (props.isOpen)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", {
                            class: "modal-base-container",
                            ref_key: "target",
                            ref: target
                        }, [
                            _createElementVNode("div", _hoisted_3, [
                                _renderSlot(_ctx.$slots, "header", {}, () => [
                                    _cache[0] || (_cache[0] = _createTextVNode(" default header ", -1))
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_4, [
                                _renderSlot(_ctx.$slots, "content", {}, () => [
                                    _cache[1] || (_cache[1] = _createTextVNode(" default content ", -1))
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_5, [
                                _renderSlot(_ctx.$slots, "footer", {}, () => [
                                    _createElementVNode("div", { class: "d-flex gap-s" }, [
                                        _createElementVNode("button", {
                                            type: "button",
                                            class: "btn btn-primary",
                                            onClick: onSubmit
                                        }, "Conferma"),
                                        _createElementVNode("button", {
                                            type: "button",
                                            class: "btn btn-secondary",
                                            onClick: onClose
                                        }, "Annulla")
                                    ])
                                ])
                            ])
                        ], 512)
                    ])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
